import { Typography } from '@mui/material';
import { TenantInformation } from 'api';

const CurrentSSOConfiguration = ({ tenantConfiguration }: { tenantConfiguration: TenantInformation }) => (
  <>
    <Typography variant="h4" gutterBottom sx={{ mt: 3 }}>
      Current SSO Configuration
    </Typography>
    <ul style={{ paddingLeft: '1.5em' }}>
      <li>
        <Typography variant="body1" gutterBottom>
          <strong>Entity ID</strong>
        </Typography>
        <Typography variant="body1" gutterBottom sx={{ color: 'text.secondary' }}>
          {tenantConfiguration?.idp_entity_id}
        </Typography>
      </li>
      <li>
        <Typography variant="body1" gutterBottom>
          <strong>SSO URL</strong>
        </Typography>
        <Typography variant="body1" gutterBottom sx={{ color: 'text.secondary' }}>
          {tenantConfiguration?.idp_sso_url}
        </Typography>
      </li>
    </ul>

    <Typography variant="body2" sx={{ pt: 1, pb: 2 }}>
      To update these settings, enter a new Metadata URL below. This will replace the current configuration.
    </Typography>
  </>
);

export default CurrentSSOConfiguration;
